import BannerDevelopment from "../../components/bannerDevelopment";
import BusinessOtimize from "../../components/businessOtimize";
import IntelligenceCards from "../../components/intelligence-cards";
import NossosServicos from "../../components/nossosServicos";
import Rodape from "../../components/rodape";

export default function Intelligence() {
    return (
        <>
            <BannerDevelopment
                title="/INTELLIGENCE"
                description={
                    <>
                        Parceria estratégica para impulsionar a{" "}
                        <strong className="font-inter-bold">inovação</strong> e
                        a{" "}
                        <strong className="font-inter-bold">eficiência</strong>{" "}
                        do seu negócio.
                    </>
                }
                backgroundUrl="../assets/banner-next2ai.png"
                imageMobile="banner-intelligence-mobile.png"
                bottomText={
                    <>
                        VERTICAL INNOVATION |{" "}
                        <span className="font-inter-bold">nex</span>
                        2ai
                    </>
                }
                bottomTextMobile="VERTICAL INNOVATION"
                brand="nex2ai"
            />
            <NossosServicos
                bannerImage="../assets/banner-nossos-servicos-intelligence.png"
                description="Transformamos dados em estratégias e projetos em produtos de alto impacto e grande poder de inovação."
                servicos={[
                    {
                        id: 1,
                        title: "IA",
                        image: "../assets/icones/brain.png",
                        link: "/ia",
                    },
                    {
                        id: 2,
                        title: "Data",
                        image: "../assets/icones/data.png",
                        link: "/data",
                    },
                    {
                        id: 3,
                        title: "Finep",
                        image: "../assets/servicos/finep_icon.svg",
                        link: "/finep",
                    },
                ]}
                bgColor="from-[#FC0021] via-[#FC0021] to-[#4B3BDB]"
            />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Inove com confiança contando com nosso
                            direcionamento estratégico
                        </span>{" "}
                        e especializado e desenvolva projetos que não somente
                        cumpram exigências, mas que excedam as expectativas e
                        gerem valor real.
                    </>
                }
                buttonText="Otimize seu negócio!"
                backgroundImage="../assets/banner-next2a.png"
                bgMobile="../assets/banner-next2a-mobile.png"
                buttonLink="/"
            />
            <IntelligenceCards />
            <Rodape />
        </>
    );
}
